
import type { IAPIJobForUser } from '@hokify/common';
import { defineComponent } from 'vue';
import type { PropType } from 'vue';

export default defineComponent({
	name: 'JobHeaderImage',
	computed: {
		companyLogo() {
			return this.job?.company?.logos?.small || '';
		},
		headerClasses() {
			if (this.$isMobile.any) {
				return '';
			}
			if (!this.$isMobile.any && this.showEducation) {
				return 'mb-3';
			}
			return 'mb-6';
		}
	},
	props: {
		job: { type: Object as PropType<IAPIJobForUser>, required: true },
		showIcons: { type: Boolean, default: false },
		activeSourcingMode: { type: Boolean, default: false },
		showEducation: { type: Boolean, default: false },
		jobRegion: { type: String, default: 'at' }
	}
});
